import React from 'react'
import './CSS/Video.css'
import video_1 from '../Assets/galary/video/video1.mp4'
import video_2 from '../Assets/galary/video/video2.mp4'

const Video = () => {
  return (
    <div className='video'>
       <div>
            <h2 className='gallery-heading'>Video Content of Completed Project with Maunacil Paints and Team</h2>
            <div className='video-container'>
                <div className='video-card'>
                    <video
                        src={video_1}
                         autoplay 
                        muted 
                        playsinline
                        controls
                    />
                </div>

                 <div className='video-card'>
                    <video
                        src={video_2}
                        autoplay 
                        muted 
                        playsinline
                        controls
                    />
                </div>
            </div>
       </div>
    </div>
  )
}

export default Video
